import React, { useState } from "react";
import { IoFastFoodSharp } from "react-icons/io5";

import { GiKnifeFork } from "react-icons/gi";
import { MdHotel } from "react-icons/md";
import { FaCamera, FaCheck, FaCarSide} from "react-icons/fa";
import BookingForm from "../common/BookingForm";

const TravelCard = ({
    title,
    description,
    image,
    include,
    index
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const isImageLeft = index % 2 === 0;

    return (
        <>
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col md:flex-row transition-transform duration-300 w-full mx-auto mb-12">
                <div className={`w-full md:w-1/2 ${!isImageLeft ? 'md:order-2' : ''}`}>
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-64 sm:h-80 md:h-[450px] lg:h-[500px] object-contain p-5"
                    />
                </div>
                <div className={`w-full md:w-1/2 p-4 sm:p-6 flex flex-col ${!isImageLeft ? 'md:order-1' : ''}`}>
                    <h4 className="text-xl sm:text-2xl font-semibold text-blue-gray-900">
                        {title} Tour Package
                    </h4>
                    <h5 className="mt-1 sm:mt-2 text-pink-600 text-sm sm:text-[16px]">
                        {description}
                    </h5>

                    {/* Icons - Responsive sizing */}
                    <div className="mt-3 sm:mt-4 text-gray-900 flex justify-between gap-1 sm:gap-2 items-center">
                        {[GiKnifeFork, MdHotel, FaCamera, FaCarSide].map((Icon, i) => (
                            <span key={i} className="bg-pink-200 text-black flex rounded-md items-center justify-center py-1 px-6 sm:py-2 sm:px-6">
                                <Icon className="text-pink-600" size={20} />
                            </span>
                        ))}
                    </div>
                    <h5 className="mt-3 sm:mt-4 mb-1 sm:mb-2 text-gray-700 text-lg sm:text-xl font-semibold">
                        Package Inclusions:
                    </h5>

                    {/* Package details - Responsive text */}
                    <div className="space-y-1 sm:space-y-2">
                        {include.map((item, i) => (

                            <p key={i} className="flex items-start gap-1 text-xs sm:text-sm md:text-[14px]">
                                <FaCheck className="text-pink-500 mt-1 flex-shrink-0" />
                                {item}
                            </p>

                        ))}
                        <p className="font-semibold">Note - Customizable as per your preferences!</p>
                    </div>

                    <button
                        className="mt-3 sm:mt-4 bg-pink-600 text-white px-3 py-1 sm:px-4 sm:py-2 rounded-md hover:bg-pink-500 transition text-sm sm:text-base"
                        onClick={() => setIsOpen(true)}
                    >
                        Book your Trip
                    </button>
                </div>
                {isOpen && <BookingForm isOpen={isOpen} setIsOpen={setIsOpen} />}
            </div>
        </>
    );
};

export default TravelCard;